<div *ngIf="spinner.isVisible | async">
    <div class="spinner-wrapper" [class.spinner-transparent]="spinner.isTransparent | async">
        <div class="spinner"></div>
    </div>
</div>